import { html, LitElement } from "../vendor/lit-element/lit-element";
import { gsap } from "gsap";

class BoneGlass extends LitElement {
  async firstUpdated() {
    // Give the browser a chance to paint
    await new Promise((r) => setTimeout(r, 0));

    const tl = gsap
      .timeline()
      .to(this, {
        opacity: 1,
      })
      .play();
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 100 440 260"
    >
      <defs>
        <clipPath id="bone-a" transform="translate(-1.88 127.46)">
          <circle cx="286.02" cy="62.52" r="25.12" style="fill: none" />
        </clipPath>
        <clipPath id="bone-b" transform="translate(-1.88 127.46)">
          <circle cx="184.35" cy="30.5" r="25.12" style="fill: none" />
        </clipPath>
        <clipPath id="bone-c" transform="translate(-1.88 127.46)">
          <circle cx="224.04" cy="166.15" r="25.12" style="fill: none" />
        </clipPath>
        <clipPath id="bone-d" transform="translate(-1.88 127.46)">
          <circle cx="98.44" cy="165.29" r="25.12" style="fill: none" />
        </clipPath>
        <radialGradient
          id="bone-e"
          cx="96.56"
          cy="292.75"
          r="25.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1463" />
          <stop offset="1" stop-color="#fff" />
        </radialGradient>
      </defs>
      <path
        d="M268.72,161V147.52a.24.24,0,0,1,.26-.26h4.66c2.64,0,4.32,1.49,4.32,3.86v6.29c0,2.38-1.68,3.86-4.32,3.86H269A.24.24,0,0,1,268.72,161Zm1.52-1h3.46a2.63,2.63,0,0,0,2.84-2.8v-5.9a2.62,2.62,0,0,0-2.84-2.83h-3.46a.09.09,0,0,0-.1.1v11.33A.09.09,0,0,0,270.24,160Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M287.1,158.71a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,287.1,158.71Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,281.86,154.11Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M291,158.65a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44A3.85,3.85,0,0,1,294.9,151a3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M306.46,151.29a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.88,2.88,0,0,1,2.56-1.53A2.23,2.23,0,0,1,306.46,151.29Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M314.76,158.71a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32A3.77,3.77,0,0,1,312,151a3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,314.76,158.71Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,309.52,154.11Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M326,154.35V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C324.68,151,326,152.37,326,154.35ZM324.6,158v-1.54a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C323.16,160.21,324.6,159.43,324.6,158Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M328.28,158.71v-.18a.24.24,0,0,1,.26-.26h.86c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66-1.16-1.38-2.48-1.78c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.81,3.66-2.81s3.72,1.19,3.72,2.77a.24.24,0,0,1-.26.26h-.82c-.16,0-.26-.06-.26-.14v-.12c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.58-2.26,1.54s1.08,1.36,2.44,1.76c1.7.48,3.64,1,3.64,3,0,1.72-1.46,2.86-3.72,2.86S328.28,160.17,328.28,158.71Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M344.7,158.71a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,344.7,158.71Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,339.46,154.11Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M355.16,147.26h.9a.24.24,0,0,1,.26.26V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.76c0-.08-.06-.1-.12,0a3.07,3.07,0,0,1-2.54,1.22,3.6,3.6,0,0,1-3.66-2.68,8.56,8.56,0,0,1-.28-2.54,9.06,9.06,0,0,1,.24-2.48,3.62,3.62,0,0,1,3.7-2.74,3.11,3.11,0,0,1,2.54,1.2c.06.08.12,0,.12,0v-4.63A.24.24,0,0,1,355.16,147.26Zm-.3,9a5.71,5.71,0,0,0-.36-2.48,2.15,2.15,0,0,0-2.1-1.5,2.3,2.3,0,0,0-2.22,1.46,4.75,4.75,0,0,0-.46,2.52,5.51,5.51,0,0,0,.36,2.42,2.3,2.3,0,0,0,2.3,1.56,2.17,2.17,0,0,0,2.14-1.54A5.57,5.57,0,0,0,354.86,156.21Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M362.64,158.71v-.18a.24.24,0,0,1,.26-.26h.86c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66-1.16-1.38-2.48-1.78c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.81,3.66-2.81s3.72,1.19,3.72,2.77a.24.24,0,0,1-.26.26H369c-.16,0-.26-.06-.26-.14v-.12c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.58-2.26,1.54s1.08,1.36,2.44,1.76c1.7.48,3.64,1,3.64,3,0,1.72-1.46,2.86-3.72,2.86S362.64,160.17,362.64,158.71Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M376.82,152.33h-2.18a.09.09,0,0,0-.1.1v5.84c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54v-6.28a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26v-.66a.24.24,0,0,1,.26-.26h1.14a.1.1,0,0,0,.1-.11V148.8a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26V151a.1.1,0,0,0,.1.11h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,376.82,152.33Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M384.8,151.29a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0A2.88,2.88,0,0,1,383.7,151,2.23,2.23,0,0,1,384.8,151.29Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M393.1,158.71a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,393.1,158.71Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,387.86,154.11Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M404.76,154.47V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-6.26a2.43,2.43,0,0,0-4.84-.4V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,404.76,154.47Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M414.16,151.15h.9a.24.24,0,0,1,.26.26v9.52c0,3.38-2.34,4.48-5.48,4.3-.18,0-.26-.1-.26-.28l0-.8c0-.18.1-.26.26-.24,2.82.12,4-.78,4-3v-.7c0-.08-.06-.12-.12,0a3.08,3.08,0,0,1-2.6,1.18,3.64,3.64,0,0,1-3.66-2.68,9.29,9.29,0,0,1-.24-2.44,8.61,8.61,0,0,1,.26-2.56A3.59,3.59,0,0,1,411.1,151a3.31,3.31,0,0,1,2.68,1.14c.06.08.12,0,.12,0v-.68A.24.24,0,0,1,414.16,151.15Zm-.26,5a7.56,7.56,0,0,0-.12-2,2.32,2.32,0,0,0-2.38-1.94,2.55,2.55,0,0,0-2.5,1.94,6.7,6.7,0,0,0-.2,2,7,7,0,0,0,.2,2,2.5,2.5,0,0,0,2.5,1.94,2.32,2.32,0,0,0,2.4-1.92A9.14,9.14,0,0,0,413.9,156.19Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M422.44,152.33h-2.18a.09.09,0,0,0-.1.1v5.84c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54v-6.28a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26v-.66a.24.24,0,0,1,.26-.26h1.14a.1.1,0,0,0,.1-.11V148.8a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26V151a.1.1,0,0,0,.1.11h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,422.44,152.33Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M432.92,154.47V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-6.26a2.43,2.43,0,0,0-4.84-.4V161a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V147.52a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v4.63c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,432.92,154.47Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M268.4,180.65a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44,4.15,4.15,0,0,1,7.82,0,9,9,0,0,1,.28,2.46,8.77,8.77,0,0,1-.28,2.46,4.13,4.13,0,0,1-7.8,0Zm6.48-.42a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.68,2.68,0,0,0-5.16,0,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.68,2.68,0,0,0,5.16,0Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M284.34,173.29a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62V183a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.88,2.88,0,0,1,2.56-1.53A2.23,2.23,0,0,1,284.34,173.29Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M296.54,173.15h.9a.24.24,0,0,1,.26.26v9.52c0,3.38-2.34,4.48-5.48,4.3-.18,0-.26-.1-.26-.28l0-.8c0-.18.1-.26.26-.24,2.82.12,4-.78,4-3v-.7c0-.08-.06-.12-.12,0a3.08,3.08,0,0,1-2.6,1.18,3.64,3.64,0,0,1-3.66-2.68,9.29,9.29,0,0,1-.24-2.44,8.61,8.61,0,0,1,.26-2.56,3.59,3.59,0,0,1,3.56-2.66,3.31,3.31,0,0,1,2.68,1.14c.06.08.12,0,.12,0v-.68A.24.24,0,0,1,296.54,173.15Zm-.26,5a7.56,7.56,0,0,0-.12-2,2.32,2.32,0,0,0-2.38-1.94,2.55,2.55,0,0,0-2.5,1.94,6.7,6.7,0,0,0-.2,2,7,7,0,0,0,.2,2,2.5,2.5,0,0,0,2.5,1.94,2.32,2.32,0,0,0,2.4-1.92A9.14,9.14,0,0,0,296.28,178.19Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M305.72,173.29a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62V183a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.88,2.88,0,0,1,2.56-1.53A2.23,2.23,0,0,1,305.72,173.29Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M307.48,180.65a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44,4.15,4.15,0,0,1,7.82,0,9,9,0,0,1,.28,2.46,8.77,8.77,0,0,1-.28,2.46,4.13,4.13,0,0,1-7.8,0Zm6.48-.42a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.68,2.68,0,0,0-5.16,0,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.68,2.68,0,0,0,5.16,0Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M319.7,183.05l-2.8-9.6a.21.21,0,0,1,.22-.3h.94a.26.26,0,0,1,.28.22l2.08,7.8c0,.08.1.08.12,0l2.14-7.8a.26.26,0,0,1,.28-.22h.88a.26.26,0,0,1,.28.22l2.18,7.8c0,.08.1.08.12,0l2.14-7.8a.28.28,0,0,1,.3-.22l.92,0a.21.21,0,0,1,.22.3l-2.84,9.58a.26.26,0,0,1-.28.22h-1a.26.26,0,0,1-.28-.22l-2.16-7.38c0-.08-.1-.08-.12,0l-2.08,7.38a.26.26,0,0,1-.28.22h-1A.26.26,0,0,1,319.7,183.05Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M336.34,174.33h-2.18a.09.09,0,0,0-.1.1v5.84c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54v-6.28a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26v-.66a.24.24,0,0,1,.26-.26h1.14a.1.1,0,0,0,.1-.11V170.8a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26V173a.1.1,0,0,0,.1.11h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,336.34,174.33Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M346.82,176.47V183a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-6.26a2.43,2.43,0,0,0-4.84-.4V183a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V169.52a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v4.63c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,346.82,176.47Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M337.76,38.2H330.5a.09.09,0,0,0-.1.09V43.2a.09.09,0,0,0,.1.1h5.06a.24.24,0,0,1,.26.26v.72a.24.24,0,0,1-.26.26H330.5a.09.09,0,0,0-.1.1V50.7a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V37.21a.23.23,0,0,1,.26-.25h8.52a.23.23,0,0,1,.26.25v.73A.24.24,0,0,1,337.76,38.2Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M344.8,41a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62V50.7a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V41.1a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,344.8,41Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M353.94,44V50.7a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V50c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92S347.5,45,350.1,45h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C352.6,40.68,353.94,42.06,353.94,44Zm-1.42,3.68V46.18a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C351.08,49.9,352.52,49.12,352.52,47.72Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M356.62,48.34a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24,2.52,2.52,0,0,0-2.58-1.82A2.46,2.46,0,0,0,358,43.86a9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M371.16,42H369a.09.09,0,0,0-.1.1V48c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54V42.12a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26V41.1a.24.24,0,0,1,.26-.26h1.14a.09.09,0,0,0,.1-.1V38.5a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,371.16,42Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M380.34,40.84h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.76c0-.08-.06-.12-.12,0a3,3,0,0,1-2.64,1.2,3.25,3.25,0,0,1-3.52-3.3V41.1a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v6.28a2.26,2.26,0,0,0,2.38,2.48,2.33,2.33,0,0,0,2.48-2.48V41.1A.24.24,0,0,1,380.34,40.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M389.66,41a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62V50.7a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V41.1a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,389.66,41Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M398,48.4a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,398,48.4Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,392.72,43.8Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M401.46,48.4v-.18a.24.24,0,0,1,.25-.26h.87c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66-1.16-1.38-2.48-1.78c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.8,3.66-2.8s3.72,1.18,3.72,2.76a.24.24,0,0,1-.26.26h-.82c-.16,0-.26-.06-.26-.14V43.5c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.58-2.26,1.54s1.08,1.36,2.44,1.76c1.7.48,3.64,1,3.64,3,0,1.72-1.46,2.86-3.72,2.86S401.46,49.86,401.46,48.4Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M8.94,123.07a3.4,3.4,0,0,1,2.16,3.38c0,2.44-1.74,3.8-4.18,3.8H2.14a.24.24,0,0,1-.26-.26V116.5a.23.23,0,0,1,.26-.25H6.78c2.54,0,4.16,1.29,4.16,3.66a3.08,3.08,0,0,1-2,3Q8.82,123,8.94,123.07ZM3.3,117.58v4.77a.09.09,0,0,0,.1.1H6.78c1.68,0,2.76-.94,2.76-2.42a2.49,2.49,0,0,0-2.76-2.54H3.4A.09.09,0,0,0,3.3,117.58Zm6.38,8.75a2.59,2.59,0,0,0-2.84-2.68H3.4a.09.09,0,0,0-.1.1v5.14a.09.09,0,0,0,.1.1H6.92A2.54,2.54,0,0,0,9.68,126.33Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M13.9,127.63a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44A3.87,3.87,0,0,1,17.82,120a3.84,3.84,0,0,1,3.88,2.74,9,9,0,0,1,.28,2.46,8.77,8.77,0,0,1-.28,2.46,3.86,3.86,0,0,1-3.88,2.78A3.86,3.86,0,0,1,13.9,127.63Zm6.48-.42a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.55,2.55,0,0,0-2.6-2,2.55,2.55,0,0,0-2.56,2,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.53,2.53,0,0,0,2.6,2A2.54,2.54,0,0,0,20.38,127.21Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M32.34,123.45V130a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-6.26a2.43,2.43,0,0,0-4.84-.4V130a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,32.34,123.45Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M41.74,127.69a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32A3.77,3.77,0,0,1,39,120a3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,41.74,127.69Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,36.5,123.09Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M57.66,125.19a9.06,9.06,0,0,1-.24,2.48,3.62,3.62,0,0,1-3.7,2.74,3.11,3.11,0,0,1-2.54-1.2c-.06-.08-.12,0-.12,0v4.62a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V120.39a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.76c0,.08.06.1.12,0A3.07,3.07,0,0,1,53.72,120a3.6,3.6,0,0,1,3.66,2.68A8.56,8.56,0,0,1,57.66,125.19Zm-1.42,0a5.51,5.51,0,0,0-.36-2.42,2.3,2.3,0,0,0-2.3-1.56,2.17,2.17,0,0,0-2.14,1.54,5.57,5.57,0,0,0-.34,2.44,5.71,5.71,0,0,0,.36,2.48,2.15,2.15,0,0,0,2.1,1.5,2.3,2.3,0,0,0,2.22-1.46A4.75,4.75,0,0,0,56.24,125.19Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M67.56,123.33V130a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24H66a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C66.22,120,67.56,121.35,67.56,123.33ZM66.14,127v-1.54a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C64.7,129.19,66.14,128.41,66.14,127Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M70.08,117.27a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,70.08,117.27ZM70.46,130v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V130a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,70.46,130Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M82.68,123.45V130a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-6.26a2.43,2.43,0,0,0-4.84-.4V130a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,75,130v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06A3.15,3.15,0,0,1,79.2,120,3.26,3.26,0,0,1,82.68,123.45Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M4.88,16.74V3.26A.24.24,0,0,1,5.14,3H9.8c2.64,0,4.32,1.48,4.32,3.86v6.28c0,2.38-1.68,3.86-4.32,3.86H5.14A.24.24,0,0,1,4.88,16.74Zm1.52-1H9.86A2.63,2.63,0,0,0,12.7,13V7.06A2.62,2.62,0,0,0,9.86,4.24H6.4a.09.09,0,0,0-.1.1V15.66A.09.09,0,0,0,6.4,15.76Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M23.26,14.44a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32A3.77,3.77,0,0,1,20.5,6.72a3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26H18a.09.09,0,0,0-.1.1A6.36,6.36,0,0,0,18,14a2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,23.26,14.44ZM18,9.84a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1H23.1a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28A2.5,2.5,0,0,0,20.5,8,2.38,2.38,0,0,0,18,9.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M27.18,14.38a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74A3.9,3.9,0,0,1,35,9.3a3.89,3.89,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24A2.52,2.52,0,0,0,31.06,8,2.46,2.46,0,0,0,28.52,9.9a9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.45,2.45,0,0,0,2.54,2,2.47,2.47,0,0,0,2.56-1.8.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a3.83,3.83,0,0,1-3.92,2.6A3.84,3.84,0,0,1,27.18,14.38Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M42.62,7a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V7.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V8.26c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,42.62,7Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M50.92,14.44a.23.23,0,0,1,.34-.12l.58.32A.23.23,0,0,1,52,15a3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1A6.36,6.36,0,0,0,45.64,14a2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,50.92,14.44Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,45.68,9.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M62.18,10.08v6.66a.24.24,0,0,1-.26.26H61a.24.24,0,0,1-.26-.26V16c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92S55.74,11,58.34,11h2.32a.09.09,0,0,0,.1-.1v-.74A2,2,0,0,0,58.42,8c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C60.84,6.72,62.18,8.1,62.18,10.08Zm-1.42,3.68V12.22a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C59.32,15.94,60.76,15.16,60.76,13.76Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M64.44,14.44v-.18A.24.24,0,0,1,64.7,14h.86c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66S69.38,13,68.06,12.56c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.8,3.66-2.8S71.88,8,71.88,9.54a.24.24,0,0,1-.26.26H70.8c-.16,0-.26-.06-.26-.14V9.54c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.58-2.26,1.54s1.08,1.36,2.44,1.76c1.7.48,3.64,1,3.64,3C72,16,70.5,17.1,68.24,17.1S64.44,15.9,64.44,14.44Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M80.86,14.44a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32A3.77,3.77,0,0,1,78.1,6.72a3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1A6.36,6.36,0,0,0,75.58,14a2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,80.86,14.44Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1H80.7a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28A2.5,2.5,0,0,0,78.1,8,2.38,2.38,0,0,0,75.62,9.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M91.32,3h.9a.24.24,0,0,1,.26.26V16.74a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V16c0-.08-.06-.1-.12,0a3.07,3.07,0,0,1-2.54,1.22,3.6,3.6,0,0,1-3.66-2.68,8.56,8.56,0,0,1-.28-2.54,9.06,9.06,0,0,1,.24-2.48,3.62,3.62,0,0,1,3.7-2.74,3.11,3.11,0,0,1,2.54,1.2c.06.08.12,0,.12,0V3.26A.24.24,0,0,1,91.32,3ZM91,11.94a5.71,5.71,0,0,0-.36-2.48A2.15,2.15,0,0,0,88.56,8a2.3,2.3,0,0,0-2.22,1.46,4.75,4.75,0,0,0-.46,2.52,5.51,5.51,0,0,0,.36,2.42,2.3,2.3,0,0,0,2.3,1.56,2.17,2.17,0,0,0,2.14-1.54A5.57,5.57,0,0,0,91,11.94Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M12.62,33.94a8.56,8.56,0,0,1-.28,2.54,3.6,3.6,0,0,1-3.66,2.68,3.07,3.07,0,0,1-2.54-1.22c-.06-.06-.12,0-.12,0v.76a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V25.26A.24.24,0,0,1,4.86,25h.9a.24.24,0,0,1,.26.26v4.62c0,.08.06.12.12,0a3.11,3.11,0,0,1,2.54-1.2,3.62,3.62,0,0,1,3.7,2.74A9.06,9.06,0,0,1,12.62,33.94Zm-1.42,0a4.75,4.75,0,0,0-.46-2.52A2.3,2.3,0,0,0,8.52,30a2.15,2.15,0,0,0-2.1,1.5,5.71,5.71,0,0,0-.36,2.48,5.57,5.57,0,0,0,.34,2.44,2.17,2.17,0,0,0,2.14,1.54,2.3,2.3,0,0,0,2.3-1.56A5.51,5.51,0,0,0,11.2,33.94Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M15.2,36.38a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44,3.87,3.87,0,0,1,3.94-2.76A3.84,3.84,0,0,1,23,31.46a9,9,0,0,1,.28,2.46A8.77,8.77,0,0,1,23,36.38a3.86,3.86,0,0,1-3.88,2.78A3.86,3.86,0,0,1,15.2,36.38ZM21.68,36a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.55,2.55,0,0,0-2.6-2,2.55,2.55,0,0,0-2.56,2,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.53,2.53,0,0,0,2.6,2A2.54,2.54,0,0,0,21.68,36Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M33.64,32.2v6.54a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V32.48a2.43,2.43,0,0,0-4.84-.4v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,33.64,32.2Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M43,36.44a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1A6.36,6.36,0,0,0,37.76,36a2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,43,36.44Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,37.8,31.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M57.3,25h.9a.24.24,0,0,1,.26.26V38.74a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V38c0-.08-.06-.1-.12,0a3.07,3.07,0,0,1-2.54,1.22,3.6,3.6,0,0,1-3.66-2.68,8.56,8.56,0,0,1-.28-2.54,9.06,9.06,0,0,1,.24-2.48,3.62,3.62,0,0,1,3.7-2.74,3.11,3.11,0,0,1,2.54,1.2c.06.08.12,0,.12,0V25.26A.24.24,0,0,1,57.3,25ZM57,33.94a5.71,5.71,0,0,0-.36-2.48,2.15,2.15,0,0,0-2.1-1.5,2.3,2.3,0,0,0-2.22,1.46,4.75,4.75,0,0,0-.46,2.52,5.51,5.51,0,0,0,.36,2.42,2.3,2.3,0,0,0,2.3,1.56,2.17,2.17,0,0,0,2.14-1.54A5.57,5.57,0,0,0,57,33.94Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M68,36.44a.23.23,0,0,1,.34-.12l.58.32A.23.23,0,0,1,69,37a3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1A6.36,6.36,0,0,0,62.68,36a2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,68,36.44Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1H67.8a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,62.72,31.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M79.62,32.2v6.54a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V32.48a2.43,2.43,0,0,0-4.84-.4v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,79.62,32.2Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M82,36.44v-.18A.24.24,0,0,1,82.3,36h.86c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66S87,35,85.66,34.56c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.8,3.66-2.8s3.72,1.18,3.72,2.76a.24.24,0,0,1-.26.26H88.4c-.16,0-.26-.06-.26-.14v-.12c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.58-2.26,1.54s1.08,1.36,2.44,1.76c1.7.48,3.64,1,3.64,3,0,1.72-1.46,2.86-3.72,2.86S82,37.9,82,36.44Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M91.74,26a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,91.74,26Zm.38,12.72v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,92.12,38.74Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M100.94,30.06H98.76a.09.09,0,0,0-.1.1V36c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54V30.16a.09.09,0,0,0-.1-.1H96a.24.24,0,0,1-.26-.26v-.66a.24.24,0,0,1,.26-.26h1.14a.09.09,0,0,0,.1-.1V26.54a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,100.94,30.06Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M103.14,42.74V42c0-.16.06-.26.14-.26h.14c1.5,0,1.94-.48,2.62-2.72a.13.13,0,0,0,0-.12l-3.36-9.76a.21.21,0,0,1,.22-.3h.94a.3.3,0,0,1,.3.22l2.58,7.84c0,.1.1.1.12,0l2.52-7.84a.26.26,0,0,1,.28-.22h1a.21.21,0,0,1,.22.3l-3.68,10.7c-.9,2.56-1.5,3.12-3.72,3.12h-.14C103.2,43,103.14,42.9,103.14,42.74Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M123.84,32.08v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V38c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92S117.4,33,120,33h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C122.5,28.72,123.84,30.1,123.84,32.08Zm-1.42,3.68V34.22a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C121,37.94,122.42,37.16,122.42,35.76Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M134.26,32.2v6.54A.24.24,0,0,1,134,39h-.9a.24.24,0,0,1-.26-.26V32.48a2.43,2.43,0,0,0-4.84-.4v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,134.26,32.2Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M143.64,25h.9a.24.24,0,0,1,.26.26V38.74a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V38c0-.08-.06-.1-.12,0a3.07,3.07,0,0,1-2.54,1.22,3.6,3.6,0,0,1-3.66-2.68,8.56,8.56,0,0,1-.28-2.54,9.06,9.06,0,0,1,.24-2.48,3.62,3.62,0,0,1,3.7-2.74,3.11,3.11,0,0,1,2.54,1.2c.06.08.12,0,.12,0V25.26A.24.24,0,0,1,143.64,25Zm-.3,8.94a5.71,5.71,0,0,0-.36-2.48,2.15,2.15,0,0,0-2.1-1.5,2.3,2.3,0,0,0-2.22,1.46,4.75,4.75,0,0,0-.46,2.52,5.51,5.51,0,0,0,.36,2.42,2.3,2.3,0,0,0,2.3,1.56A2.17,2.17,0,0,0,143,36.38,5.57,5.57,0,0,0,143.34,33.94Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M18.08,54.1v6.64a.24.24,0,0,1-.26.26h-.88a.24.24,0,0,1-.26-.26V54.38A2.2,2.2,0,0,0,14.4,52,2.22,2.22,0,0,0,12,54.34v6.4a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V54.38A2.19,2.19,0,0,0,8.34,52,2.18,2.18,0,0,0,6,54.34v6.4a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.7c0,.08.06.12.12,0a3.21,3.21,0,0,1,2.64-1.14,3,3,0,0,1,2.88,1.6c0,.08.08.08.12,0a3.28,3.28,0,0,1,3.06-1.62A3.06,3.06,0,0,1,18.08,54.1Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M20.72,48a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,20.72,48Zm.38,12.72v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,21.1,60.74Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M25.58,58.38a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24A2.52,2.52,0,0,0,29.46,52a2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.45,2.45,0,0,0,2.54,2A2.47,2.47,0,0,0,32,58.12a.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a3.83,3.83,0,0,1-3.92,2.6A3.84,3.84,0,0,1,25.58,58.38Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M41,51a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84A.24.24,0,0,1,37,61h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26H37a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,41,51Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M42.78,58.38a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44,4.15,4.15,0,0,1,7.82,0,9,9,0,0,1,.28,2.46,8.77,8.77,0,0,1-.28,2.46,4.13,4.13,0,0,1-7.8,0ZM49.26,58a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.68,2.68,0,0,0-5.16,0,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.68,2.68,0,0,0,5.16,0Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M60.82,54.08v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V60c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92S54.38,55,57,55H59.3a.09.09,0,0,0,.1-.1v-.74A2,2,0,0,0,57.06,52c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C59.48,50.72,60.82,52.1,60.82,54.08ZM59.4,57.76V56.22a.09.09,0,0,0-.1-.1H57.2c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C58,59.94,59.4,59.16,59.4,57.76Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M68.74,51a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1A2.47,2.47,0,0,0,65,54.9v5.84a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,68.74,51Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M70.48,58.38a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1A.24.24,0,0,1,77,54a1,1,0,0,0,0-.24A2.52,2.52,0,0,0,74.36,52a2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M88.42,54.2v6.54a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V54.48a2.43,2.43,0,0,0-4.84-.4v6.66a.24.24,0,0,1-.26.26H81a.24.24,0,0,1-.26-.26V47.26A.24.24,0,0,1,81,47h.9a.24.24,0,0,1,.26.26v4.62c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,88.42,54.2Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M91.1,48a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,91.1,48Zm.38,12.72v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,91.48,60.74Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M100.3,52.06H98.12a.09.09,0,0,0-.1.1V58c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54V52.16a.09.09,0,0,0-.1-.1H95.4a.24.24,0,0,1-.26-.26v-.66a.24.24,0,0,1,.26-.26h1.14a.09.09,0,0,0,.1-.1V48.54a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,100.3,52.06Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M109.3,58.44a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26H104a.09.09,0,0,0-.1.1A6.36,6.36,0,0,0,104,58a2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,109.3,58.44Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,104.06,53.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M113.22,58.38A8.81,8.81,0,0,1,113,55.9a9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24A2.52,2.52,0,0,0,117.1,52a2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M127.76,52.06h-2.18a.09.09,0,0,0-.1.1V58c0,1.3.58,1.74,1.78,1.74h.44A.24.24,0,0,1,128,60v.7a.26.26,0,0,1-.26.28H127c-1.74,0-2.92-.46-2.92-2.54V52.16a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26v-.66a.24.24,0,0,1,.26-.26H124a.09.09,0,0,0,.1-.1V48.54a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,127.76,52.06Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M136.94,50.88h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V60c0-.08-.06-.12-.12,0a3,3,0,0,1-2.64,1.2,3.25,3.25,0,0,1-3.52-3.3v-6.7a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v6.28a2.26,2.26,0,0,0,2.38,2.48,2.33,2.33,0,0,0,2.48-2.48V51.14A.24.24,0,0,1,136.94,50.88Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M146.26,51a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-9.6a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,146.26,51Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M154.56,58.44a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,154.56,58.44Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,149.32,53.84Z"
        transform="translate(-1.88 127.46)"
        style="fill: #6f6f6e"
      />
      <path
        d="M204.32,78.33c6.88-10.35,17.58-27.8,24.29-43a113.3,113.3,0,0,1,7-14.16,31.86,31.86,0,0,1,10.94-11.16,5,5,0,0,1,2.83-.87,2.05,2.05,0,0,1,2,1.87c-1.88,1.74-2.09,5.28-.36,7.56a6.25,6.25,0,0,0,7.7,1.64c3.24-1.77,4.39-6.16,7.69-7.81,3.06-1.52,7,.09,8.88,3s1.92,6.59,1,9.89c-.79,2.94-2.53,5.91-5.41,6.92-3.55,1.24-7.33-.87-11.08-1.09-4-.23-7.82,1.73-10.72,4.47s-5,6.18-7,9.59q-15.89,26.31-31.75,52.59-14.15,21.67-30.38,41.89c-5.62,7-11.57,14.11-14.07,22.73-1.27,4.4-1.82,9.46-5.32,12.42a8.89,8.89,0,0,1-11.27-.13c-1.95-1.74-3-4.3-5.08-5.95-3.47-2.81-9.14-2.55-11.63-6.27-2-3-.79-7.16,1.64-9.77s5.81-4.07,9-5.75c14.27-7.61,35.17-32.92,35.17-32.92S198.19,87.55,204.32,78.33Z"
        transform="translate(-1.88 127.46)"
        style="fill: #fff; stroke: #1d1d1b; stroke-miterlimit: 10"
      />
      <path
        d="M249.36,9.13a20,20,0,0,0,.16,25.64,16.06,16.06,0,0,1,13-3.45c2.2.4,4.37,1.27,6.59,1a8,8,0,0,0,5.46-3.3,12.29,12.29,0,0,0,2.2-6.11,11.41,11.41,0,0,0-2.12-8.36c-1.87-2.28-5.25-3.44-7.93-2.21-2.89,1.33-4.14,4.8-6.64,6.78a6.91,6.91,0,0,1-7.37.83,5.49,5.49,0,0,1-2.52-6.7c.25-.57.61-1.1.84-1.68a2.17,2.17,0,0,0,0-1.83A1.57,1.57,0,0,0,249.36,9.13Z"
        transform="translate(-1.88 127.46)"
        style="fill: #e1e2e3"
      />
      <polyline
        points="2.72 193.02 157.24 193.02 172.61 171.06"
        style="
    fill: none;
    stroke: #6f6f6e;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <polyline
        points="432.44 317.87 265.42 317.87 242.8 304.13"
        style="
    fill: none;
    stroke: #6f6f6e;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <path
        d="M266.09,12.48a4.45,4.45,0,0,0-2.57,4,10.79,10.79,0,0,0,1.22,4.85,23.2,23.2,0,0,1,1.82,4.7,5.62,5.62,0,0,1-1,4.78c-.25.28-.55.69-.31,1a.7.7,0,0,0,.35.19,8,8,0,0,0,7.73-2.11,12.14,12.14,0,0,0,3.35-7.55,12,12,0,0,0-.83-6.09A8,8,0,0,0,271.58,12C269.65,11.21,267.58,11.91,266.09,12.48Z"
        transform="translate(-1.88 127.46)"
        style="fill: #d0d2d3"
      />
      <path
        d="M133.2,153.78a5.41,5.41,0,0,0,.92,6.57,8.24,8.24,0,0,0,6.63,2.07c1.67-.17,3.34-.71,5-.4,2.49.47,4.2,2.71,5.56,4.85s2.77,4.49,5.12,5.43a5.88,5.88,0,0,0,7.49-3.49,9,9,0,0,1-14.54,5.83c-1.82-1.45-3-3.55-4.67-5.2a12.77,12.77,0,0,0-4.52-2.89c-1.72-.63-3.59-.9-5.17-1.81a7.18,7.18,0,0,1-3.44-5A7.87,7.87,0,0,1,133.2,153.78Z"
        transform="translate(-1.88 127.46)"
        style="fill: #d0d2d3"
      />
      <path
        d="M276.6,24s-5.3,5.73-15.14,3.51a18.21,18.21,0,0,0-20,8.16c-2.77,4.92-41,70.78-50.82,81.13-9.05,9.49-16.39,20.81-23.75,31.61-2.15,3.16-4.84,6.33-5.59,10.17-.69,3.52.81,7.24,2.57,10.23,0,0,2.22-10.16,6.36-16.19s26.89-35.71,26.89-35.71a388.3,388.3,0,0,0,29.69-46.6c13.08-24.73,22.21-34.73,22.21-34.73s4.18-5.06,10.72-4.47,9.27,3.23,13.1-.28S276.6,24,276.6,24"
        transform="translate(-1.88 127.46)"
        style="fill: #231f20; opacity: 0.2"
      />
      <path
        d="M204.32,78.33c6.88-10.35,17.58-27.8,24.29-43a113.3,113.3,0,0,1,7-14.16,31.86,31.86,0,0,1,10.94-11.16,5,5,0,0,1,2.83-.87,2.05,2.05,0,0,1,2,1.87c-1.88,1.74-2.09,5.28-.36,7.56a6.25,6.25,0,0,0,7.7,1.64c3.24-1.77,4.39-6.16,7.69-7.81,3.06-1.52,7,.09,8.88,3s1.92,6.59,1,9.89c-.79,2.94-2.53,5.91-5.41,6.92-3.55,1.24-7.33-.87-11.08-1.09-4-.23-7.82,1.73-10.72,4.47s-5,6.18-7,9.59q-15.89,26.31-31.75,52.59-14.15,21.67-30.38,41.89c-5.62,7-11.57,14.11-14.07,22.73-1.27,4.4-1.82,9.46-5.32,12.42a8.89,8.89,0,0,1-11.27-.13c-1.95-1.74-3-4.3-5.08-5.95-3.47-2.81-9.14-2.55-11.63-6.27-2-3-.79-7.16,1.64-9.77s5.81-4.07,9-5.75c14.27-7.61,35.17-32.92,35.17-32.92S198.19,87.55,204.32,78.33Z"
        transform="translate(-1.88 127.46)"
        style="fill: none; stroke: #1d1d1b; stroke-miterlimit: 10"
      />
      <polyline
        points="0 263.86 82.4 263.86 92.24 275.44"
        style="
    fill: none;
    stroke: #6f6f6e;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <circle cx="284.14" cy="189.98" r="25.12" style="fill: #fff" />
      <g style="clip-path: url(#bone-a)">
        <path
          d="M323-10.63a33.22,33.22,0,0,0-8.32,20.9,33.23,33.23,0,0,0,7.07,21.35,26.43,26.43,0,0,1,21.64-4.91c3.6.79,7.13,2.35,10.8,2.1a13.26,13.26,0,0,0,9.2-5.12,20.32,20.32,0,0,0,4-9.94c.67-4.82-.05-10-3-13.9s-8.43-6-12.92-4.1c-4.86,2-7.11,7.65-11.35,10.77a11.37,11.37,0,0,1-12.2.94c-3.72-2.19-5.61-7.29-3.75-11.19.44-.93,1.07-1.78,1.48-2.73a3.51,3.51,0,0,0,.12-3A2.55,2.55,0,0,0,323-10.63Z"
          transform="translate(-1.88 127.46)"
          style="fill: #e1e2e3"
        />
        <path
          d="M350.38-4.14c-2.63.9-4.24,3.71-4.46,6.48a17.79,17.79,0,0,0,1.72,8.07,37,37,0,0,1,2.72,7.86c.45,2.74,0,5.79-1.89,7.81-.43.45-1,1.1-.57,1.6a1.23,1.23,0,0,0,.56.34c4.37,1.53,9.45.07,12.88-3a20,20,0,0,0,6-12.23,20,20,0,0,0-1-10.1,13.18,13.18,0,0,0-6.81-7.31C356.33-6,352.87-5,350.38-4.14Z"
          transform="translate(-1.88 127.46)"
          style="fill: #d0d2d3"
        />
        <path
          d="M129.78,226.56c-2.2,3.27-1.28,8,1.51,10.82s7,3.81,10.94,3.41c2.75-.27,5.51-1.16,8.22-.65,4.11.77,6.94,4.47,9.18,8s4.57,7.41,8.44,9a9.72,9.72,0,0,0,12.36-5.77,14.87,14.87,0,0,1-24,9.62c-3-2.4-5-5.86-7.71-8.58a21,21,0,0,0-7.45-4.76c-2.84-1-5.92-1.48-8.54-3a11.86,11.86,0,0,1-5.67-8.3A12.92,12.92,0,0,1,129.78,226.56Z"
          transform="translate(-1.88 127.46)"
          style="fill: #d0d2d3"
        />
        <path
          d="M287,80.3a.17.17,0,0,1,0-.12V76.83l-.86-1.2a.26.26,0,0,1,0-.23l.85-2-2.09-2.78a.23.23,0,0,1,0-.14V68.36l-.68-1a.23.23,0,0,1,0-.24l.66-1.31-1-1.51a.36.36,0,0,1,0-.09L283.07,60h-.7a.22.22,0,0,1-.21-.12l-.72-1.43a.18.18,0,0,1,0-.1V55.5c0-.83-1.16-.84-1.21-.84a.24.24,0,0,1-.23-.29l.48-2.06h-.79a.23.23,0,0,1-.23-.23v-4.8a595,595,0,0,1-32.39,54.84C237,117.34,204.14,161,204.14,161s-34.48,41.75-58,54.29c-5.19,2.77-10.76,5.18-14.77,9.49s-6,11.23-2.7,16.11c4.1,6.12,13.45,5.69,19.17,10.33,3.35,2.72,5.16,6.95,8.38,9.82a14.65,14.65,0,0,0,18.59.21c5.76-4.88,6.67-13.22,8.77-20.47,4.13-14.22,13.93-26,23.2-37.5Q233.5,170,256.86,134.18q15.69-26,31.4-52Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #231f20;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 0.467631316910455px;
    "
        />
        <path
          d="M365.8.27c-2.95-4.79-9.43-7.58-14.52-5.19-5.51,2.59-7.57,9.79-13,12.58a10.29,10.29,0,0,1-12.64-3C322.9.85,323.38-5,326.55-7.78c.08-1.65-1.56-3-3.2-3.15a8.41,8.41,0,0,0-4.7,1.33C311-5.49,305,1.12,300.19,8.39s-8.3,15.23-12,23.09c-2.28,4.87-4.83,9.88-7.54,14.91l-.12,5.48h.85a.25.25,0,0,1,.18.1.23.23,0,0,1,0,.2l-.53,2.06c.6.09,1.38.44,1.36,1.32l-.06,2.83.6,1.26.75,0a.24.24,0,0,1,.23.2l.62,4.3,1,1.6a.23.23,0,0,1,0,.24l-.69,1.3.63,1a.31.31,0,0,1,0,.13l-.05,2.09,2.06,2.86a.27.27,0,0,1,0,.23l-.9,2,.8,1.17a.23.23,0,0,1,0,.14l-.07,3.35,1,1.65,21.46-33.81c3.52-5.54,7.1-11.16,12-15.55s11.29-7.5,17.83-7c6.17.5,12.33,4.12,18.23,2.21,4.78-1.55,7.76-6.39,9.17-11.21C368.72,11.21,368.76,5.06,365.8.27Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #231f20;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 0.467631316910455px;
    "
        />
        <path
          d="M287.25,80.39a.2.2,0,0,1,0-.11l.07-3.26L286,75.56a.22.22,0,0,1,0-.3l1.35-1.66-2-2.42c-21.1,35.52-50.4,83.52-60.75,94.39-14.92,15.65-27,34.31-39.16,52.13-3.55,5.2-8,10.42-9.23,16.77-1.14,5.79,1.34,11.93,4.26,16.86,0,0,3.64-16.75,10.47-26.69s44.35-58.9,44.35-58.9,27.37-36.05,48.95-76.83q1.92-3.63,3.77-7Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M368,14.5s-9,9.23-25.09,5.19-28.45,4.69-33.22,12.69C308,35.27,298.4,51,286,70.8l2.14,2.75a.26.26,0,0,1,0,.3l-1.38,1.61L288,76.87a.25.25,0,0,1,.06.16l-.15,3.3.53,1.17c20.22-34.84,33.75-49,33.75-49s7.09-8.17,17.84-6.94,15.15,5.68,21.61,0S368,14.5,368,14.5Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
      </g>
      <circle
        cx="284.14"
        cy="189.98"
        r="25.12"
        style="fill: none; stroke: #1c1463; stroke-miterlimit: 10"
      />
      <circle cx="182.47" cy="157.96" r="25.12" style="fill: #fff" />
      <g style="clip-path: url(#bone-b)">
        <ellipse
          cx="184.41"
          cy="25.23"
          rx="3"
          ry="4.67"
          transform="translate(86.96 312.4) rotate(-66.89)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="184.41"
          cy="25.23"
          rx="3"
          ry="4.67"
          transform="translate(86.96 312.4) rotate(-66.89)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M184.71,24.53c2,.88,3.51,2.2,3.59,3.18a1.87,1.87,0,0,0,.36-.55c.65-1.52-.75-3.57-3.12-4.58s-4.82-.6-5.47.92a2,2,0,0,0-.15.64C180.69,23.52,182.65,23.65,184.71,24.53Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="188.9"
          cy="44.39"
          rx="3"
          ry="4.67"
          transform="translate(122.25 354.76) rotate(-83.72)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="188.9"
          cy="44.39"
          rx="3"
          ry="4.67"
          transform="translate(122.25 354.76) rotate(-83.72)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M189,43.63c2.21.25,4,1.1,4.36,2a2,2,0,0,0,.18-.63c.18-1.64-1.75-3.21-4.31-3.49s-4.79.83-5,2.47a1.77,1.77,0,0,0,0,.65C184.84,43.83,186.77,43.39,189,43.63Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="195.91"
          cy="53.32"
          rx="3.91"
          ry="5.33"
          transform="translate(29.4 299.61) rotate(-51.05)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="195.91"
          cy="53.32"
          rx="3.91"
          ry="5.33"
          transform="translate(29.4 299.61) rotate(-51.05)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M196.54,52.55c2,1.6,3.09,3.6,2.79,4.81a2.67,2.67,0,0,0,.63-.58c1.36-1.68.61-4.54-1.68-6.39s-5.25-2-6.6-.31a2.91,2.91,0,0,0-.43.74C192.37,50.27,194.55,51,196.54,52.55Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="192.78"
          cy="23.03"
          rx="3"
          ry="3.1"
          transform="translate(94.07 318.78) rotate(-66.89)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="192.78"
          cy="23.03"
          rx="3"
          ry="3.1"
          transform="translate(94.07 318.78) rotate(-66.89)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M193.08,22.34c1.37.58,2.25,1.66,2.19,2.58a2.84,2.84,0,0,0,.33-.56,3.11,3.11,0,0,0-5.71-2.44,2.94,2.94,0,0,0-.19.62C190.32,21.87,191.72,21.75,193.08,22.34Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="178.31"
          cy="11.13"
          rx="3"
          ry="3.24"
          transform="translate(141.15 313.73) rotate(-82.18)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="178.31"
          cy="11.13"
          rx="3"
          ry="3.24"
          transform="translate(141.15 313.73) rotate(-82.18)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M178.42,10.38c1.53.21,2.72,1,2.92,1.93a3.13,3.13,0,0,0,.16-.62,3.25,3.25,0,0,0-6.41-.89,2.84,2.84,0,0,0,0,.65C175.52,10.64,176.88,10.17,178.42,10.38Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="182.61"
          cy="32.29"
          rx="3"
          ry="2.71"
          transform="translate(32.92 271.74) rotate(-47.18)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="182.61"
          cy="32.29"
          rx="3"
          ry="2.71"
          transform="translate(32.92 271.74) rotate(-47.18)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M183.12,31.74a2.66,2.66,0,0,1,.92,2.91,3.89,3.89,0,0,0,.48-.43,2.73,2.73,0,1,0-4-3.69,3.21,3.21,0,0,0-.39.52A2.64,2.64,0,0,1,183.12,31.74Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="175.89"
          cy="26.5"
          rx="3"
          ry="3.52"
          transform="translate(105.91 318.28) rotate(-76.06)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="175.89"
          cy="26.5"
          rx="3"
          ry="3.52"
          transform="translate(105.91 318.28) rotate(-76.06)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M176.07,25.76c1.63.41,2.84,1.38,3,2.3a3.13,3.13,0,0,0,.24-.6,3.57,3.57,0,0,0-6.84-1.7,2.88,2.88,0,0,0-.07.65C172.92,25.65,174.44,25.36,176.07,25.76Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="162.03"
          cy="44.46"
          rx="3"
          ry="3.52"
          transform="translate(77.96 318.47) rotate(-76.06)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="162.03"
          cy="44.46"
          rx="3"
          ry="3.52"
          transform="translate(77.96 318.47) rotate(-76.06)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M162.21,43.73c1.64.4,2.84,1.37,3,2.29a2.69,2.69,0,0,0,.24-.6,3.56,3.56,0,0,0-6.83-1.7,2.46,2.46,0,0,0-.08.65C159.06,43.61,160.58,43.32,162.21,43.73Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="200.16"
          cy="18.78"
          rx="3"
          ry="2.71"
          transform="translate(48.45 280.29) rotate(-47.18)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="200.16"
          cy="18.78"
          rx="3"
          ry="2.71"
          transform="translate(48.45 280.29) rotate(-47.18)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M200.68,18.23a2.67,2.67,0,0,1,.91,2.91,2.8,2.8,0,0,0,.49-.43,2.87,2.87,0,0,0,0-4,2.86,2.86,0,0,0-4,.35,2.72,2.72,0,0,0-.39.52A2.67,2.67,0,0,1,200.68,18.23Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="193.44"
          cy="12.99"
          rx="3"
          ry="3.52"
          transform="translate(132.35 325.07) rotate(-76.06)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="193.44"
          cy="12.99"
          rx="3"
          ry="3.52"
          transform="translate(132.35 325.07) rotate(-76.06)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M193.62,12.26c1.64.4,2.84,1.37,3,2.3a2.5,2.5,0,0,0,.24-.61,3.56,3.56,0,0,0-6.83-1.7,2.09,2.09,0,0,0-.07.65C190.47,12.14,192,11.85,193.62,12.26Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="208.1"
          cy="29.4"
          rx="3"
          ry="3.52"
          transform="translate(127.56 351.75) rotate(-76.06)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="208.1"
          cy="29.4"
          rx="3"
          ry="3.52"
          transform="translate(127.56 351.75) rotate(-76.06)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M208.29,28.66c1.63.41,2.83,1.37,3,2.3a2.16,2.16,0,0,0,.24-.61,3.56,3.56,0,0,0-6.83-1.69,2.81,2.81,0,0,0-.07.65C205.13,28.55,206.65,28.25,208.29,28.66Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="201.31"
          cy="36.47"
          rx="3"
          ry="4.67"
          transform="translate(86.89 334.78) rotate(-66.89)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="201.31"
          cy="36.47"
          rx="3"
          ry="4.67"
          transform="translate(86.89 334.78) rotate(-66.89)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M201.61,35.77c-2.06-.87-4-1-4.79-.39a2.06,2.06,0,0,1,.15-.64c.65-1.52,3.1-1.93,5.47-.92s3.77,3.07,3.12,4.59a2.17,2.17,0,0,1-.36.55C205.12,38,203.66,36.65,201.61,35.77Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="197.45"
          cy="42.66"
          rx="3"
          ry="2.71"
          transform="translate(141.33 364.71) rotate(-86.61)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="197.45"
          cy="42.66"
          rx="3"
          ry="2.71"
          transform="translate(141.33 364.71) rotate(-86.61)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M197.5,41.9a2.65,2.65,0,0,0-2.73,1.36,2.81,2.81,0,0,1,0-.65,2.73,2.73,0,1,1,5.42.32,3.29,3.29,0,0,1-.11.64A2.66,2.66,0,0,0,197.5,41.9Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="206.29"
          cy="43.5"
          rx="3"
          ry="3.52"
          transform="translate(57.49 322.16) rotate(-57.73)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="206.29"
          cy="43.5"
          rx="3"
          ry="3.52"
          transform="translate(57.49 322.16) rotate(-57.73)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M206.69,42.86c-1.42-.9-2.95-1.1-3.71-.55a2.4,2.4,0,0,1,.27-.59,3.56,3.56,0,0,1,5.95,3.76,2.53,2.53,0,0,1-.42.5C209,45.06,208.12,43.76,206.69,42.86Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="165.08"
          cy="23.3"
          rx="2.52"
          ry="3.42"
          transform="translate(132.26 314.57) rotate(-87.34)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="165.08"
          cy="23.3"
          rx="2.52"
          ry="3.42"
          transform="translate(132.26 314.57) rotate(-87.34)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M165.11,22.66c1.63.08,3,.68,3.27,1.43a1.62,1.62,0,0,0,.1-.54c.07-1.39-1.41-2.59-3.29-2.67s-3.47,1-3.53,2.35a1.69,1.69,0,0,0,.06.55C162.09,23.07,163.47,22.58,165.11,22.66Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="192.18"
          cy="30.35"
          rx="1.88"
          ry="2.71"
          transform="translate(51.24 293.88) rotate(-53.35)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="192.18"
          cy="30.35"
          rx="1.88"
          ry="2.71"
          transform="translate(51.24 293.88) rotate(-53.35)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M192.47,30c1,.77,1.66,1.75,1.55,2.34a1.58,1.58,0,0,0,.3-.28c.62-.83.14-2.23-1.06-3.13s-2.68-.95-3.3-.11a1.55,1.55,0,0,0-.19.36C190.31,28.87,191.42,29.19,192.47,30Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <ellipse
          cx="165.4"
          cy="37.82"
          rx="1.88"
          ry="2.71"
          transform="matrix(0.6, -0.8, 0.8, 0.6, 34.45, 275.41)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <ellipse
          cx="165.4"
          cy="37.82"
          rx="1.88"
          ry="2.71"
          transform="matrix(0.6, -0.8, 0.8, 0.6, 34.45, 275.41)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M165.69,37.44c1,.77,1.66,1.75,1.56,2.34a1.28,1.28,0,0,0,.29-.28c.62-.83.15-2.23-1.06-3.13s-2.68-.95-3.3-.11a1.22,1.22,0,0,0-.18.36C163.54,36.35,164.65,36.66,165.69,37.44Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M182.5,43.38s0,0,0-.05l0,0a2.39,2.39,0,0,0-.16-2,1.58,1.58,0,0,0,.12-.15l0,0,0,0c.9-1.38-.12-3.65-2.28-5.05a5.47,5.47,0,0,0-4.28-.91l-.09,0c-2.37-1-4.82-.6-5.47.92l0,.06,0,0a2,2,0,0,0-.14.64l0,0c-.05,1.4,1.25,3,3.27,3.87l.26.09c.12,1.33,1.37,2.78,3.25,3.58s4.08.68,5-.32l0,0A1.84,1.84,0,0,0,182.5,43.38Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M182.57,43.23a2.39,2.39,0,0,0-.16-2,.88.88,0,0,0,.12-.15l0,0,0-.05c.9-1.38-.12-3.65-2.28-5A5.47,5.47,0,0,0,176,35l-.09,0c-2.37-1-4.82-.6-5.47.92a.13.13,0,0,0,0,.06.09.09,0,0,0,0,0,1.71,1.71,0,0,0-.15.63l.05,0a1.41,1.41,0,0,0,0,.2c.94-1.35,3.41-1.27,5.53.17L176,37a5.44,5.44,0,0,1,4,1.72c1.85,1.8,2.42,4.21,1.27,5.4,0,0,0,0-.05,0l0,0-.15.13s0,.08,0,.12a2.76,2.76,0,0,0,1.12-.66.08.08,0,0,1,0,.05,2.09,2.09,0,0,0,.36-.55.07.07,0,0,1,0,0Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M182.52,43.39a2.21,2.21,0,0,0,.18-.76,2.5,2.5,0,0,0-.06-.67c0-.08-.27-.67-.25-.69a1.58,1.58,0,0,0,.12-.15l0,0,0,0c.9-1.38-.12-3.65-2.28-5.05a5.47,5.47,0,0,0-4.28-.91l-.09,0c-2.37-1-4.82-.6-5.47.92l0,.06a3,3,0,0,0,.68,2.72,6.09,6.09,0,0,0,2.37,1.77l.09,0,.26.09c.12,1.33,1.37,2.78,3.25,3.58a5,5,0,0,0,5-.3l.1-.07A1.42,1.42,0,0,0,182.52,43.39Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M150,29.54s0,0,0,0,0,0,0-.06a2.36,2.36,0,0,1,1.55-1.27l0-.2s0,0,0,0,0,0,0-.06c.38-1.61,2.72-2.43,5.23-1.84a5.38,5.38,0,0,1,3.61,2.46l.1,0c2.37,1,3.77,3.07,3.12,4.59l0,0s0,0,0,.05a1.69,1.69,0,0,1-.36.55.43.43,0,0,0,0,0c-1,1-3,1.18-5.05.32L158,33.9c-1,.83-2.95.93-4.83.13s-3.32-2.47-3.27-3.87l0,0A2,2,0,0,1,150,29.54Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M150.07,29.39a2.39,2.39,0,0,1,1.56-1.27,1.36,1.36,0,0,1,0-.2.08.08,0,0,0,0-.05s0,0,0-.06c.38-1.61,2.72-2.43,5.23-1.84a5.38,5.38,0,0,1,3.61,2.46l.1,0c2.37,1,3.77,3.07,3.12,4.59l0,.05,0,0a1.84,1.84,0,0,1-.35.55l0-.05a1.12,1.12,0,0,1-.16.13c.33-1.62-1.43-3.35-3.95-3.88h-.1a5.38,5.38,0,0,0-4-1.71c-2.57-.1-4.71,1.17-4.77,2.82v.06s0,0,0,.05,0,.13,0,.2l-.09.06a2.56,2.56,0,0,1-.3-1.26l-.05,0a1.92,1.92,0,0,1,.14-.63l0-.05A.13.13,0,0,1,150.07,29.39Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M150,29.54a2.41,2.41,0,0,1,.42-.66,2.45,2.45,0,0,1,.53-.42c.07,0,.66-.27.66-.29l0-.2s0,0,0,0,0,0,0-.06c.38-1.61,2.72-2.43,5.23-1.84a5.38,5.38,0,0,1,3.61,2.46l.1,0c2.37,1,3.77,3.07,3.12,4.59l0,0a3,3,0,0,1-2.43,1.4,6,6,0,0,1-2.93-.49l-.08,0L158,33.9c-1,.83-2.95.93-4.83.13a5,5,0,0,1-3.28-3.85s0-.08,0-.12A1.09,1.09,0,0,1,150,29.54Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M179.7,50.16l.05,0s0,0,0,0a2.4,2.4,0,0,1,2-.38c0-.05.07-.11.11-.15l.05,0,0-.05c1.1-1.23,3.55-.84,5.48.87a5.41,5.41,0,0,1,2,3.89l.07.07c1.6,2,1.85,4.5.55,5.53l-.05,0,0,0a2.42,2.42,0,0,1-.57.31.13.13,0,0,1,0-.06c-1.34.42-3.23-.41-4.6-2.12-.06-.08-.1-.16-.15-.23-1.32.23-3-.59-4.31-2.19s-1.74-3.76-1-5h0A2,2,0,0,1,179.7,50.16Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M179.83,50.06a2.4,2.4,0,0,1,2-.38,1.67,1.67,0,0,1,.12-.16l0,0,0-.05c1.1-1.24,3.56-.85,5.48.87a5.4,5.4,0,0,1,2,3.89l.07.07c1.6,2,1.85,4.49.55,5.52l0,0,0,0a1.76,1.76,0,0,1-.57.31.43.43,0,0,0,0-.05l-.2,0c1.05-1.27.33-3.63-1.62-5.29l-.08-.06a5.42,5.42,0,0,0-2.72-3.43c-2.22-1.31-4.7-1.22-5.54.21l0,0,0,0a.91.91,0,0,0-.09.17H179a2.71,2.71,0,0,1,.34-1.26h-.06a1.72,1.72,0,0,1,.44-.49s0,0,.05,0Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M179.69,50.15a2.26,2.26,0,0,1,1.35-.5c.08,0,.71.08.73.06s.07-.11.11-.15l.05,0,0-.05c1.1-1.23,3.55-.84,5.48.87a5.41,5.41,0,0,1,2,3.89l.07.07c1.6,2,1.85,4.5.55,5.53l-.05,0a3,3,0,0,1-2.8.07,6,6,0,0,1-2.34-1.82l-.06-.07c-.06-.08-.1-.16-.15-.23-1.32.23-3-.59-4.31-2.19a5,5,0,0,1-1-4.94l0-.12A1.07,1.07,0,0,1,179.69,50.15Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M189.56,16.74a.08.08,0,0,1,0,0,.11.11,0,0,1,0-.05,2.8,2.8,0,0,0-1.19-1.49c0-.06,0-.13,0-.19a.14.14,0,0,1,0-.06v-.05a3.67,3.67,0,0,0-3.93-2.66,3,3,0,0,0-2.64,1.75h-.07a3.18,3.18,0,0,0-2.22,3.88.14.14,0,0,1,0,.06s0,0,0,.05a2.43,2.43,0,0,0,.27.59s0,0,0-.05a3.29,3.29,0,0,0,3.77,1.17l.18-.08a3.41,3.41,0,0,0,5.94-2.22l0,0A2.48,2.48,0,0,0,189.56,16.74Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M189.51,16.59a2.8,2.8,0,0,0-1.19-1.49,1.23,1.23,0,0,0,0-.19.14.14,0,0,0,0-.06v0a3.67,3.67,0,0,0-3.93-2.66,3,3,0,0,0-2.63,1.75h-.07a3.17,3.17,0,0,0-2.23,3.88l0,0a.13.13,0,0,0,0,.06,2.46,2.46,0,0,0,.28.59.09.09,0,0,1,0-.05,1.58,1.58,0,0,0,.12.15,2.72,2.72,0,0,1,2.85-3h.08a2.84,2.84,0,0,1,2.95-1,4.28,4.28,0,0,1,3.61,3.52s0,0,0,.05a.13.13,0,0,1,0,.06,1.2,1.2,0,0,1,0,.19l.07.07a2.71,2.71,0,0,0,.2-1.16l0,0a2.91,2.91,0,0,0-.13-.64s0,0,0-.05S189.52,16.6,189.51,16.59Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M189.57,16.74a3,3,0,0,0-.33-.7,2.14,2.14,0,0,0-.4-.49c-.05-.05-.5-.37-.5-.4s0-.13,0-.19a.14.14,0,0,1,0-.06v-.05a3.67,3.67,0,0,0-3.93-2.66,3,3,0,0,0-2.64,1.75h-.07a3.18,3.18,0,0,0-2.22,3.88.14.14,0,0,1,0,.06,3.09,3.09,0,0,0,1.84,1.75,3.27,3.27,0,0,0,2.16,0l.07,0,.18-.08a3.3,3.3,0,0,0,3.59.95,3.37,3.37,0,0,0,2.36-3.14v-.12A1.43,1.43,0,0,0,189.57,16.74Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M191.18,5.52a.14.14,0,0,1,0-.06l0,0A2.74,2.74,0,0,0,190,3.92c0-.06,0-.13,0-.19a.14.14,0,0,1,0-.06s0,0,0,0A3.66,3.66,0,0,0,186,1a3,3,0,0,0-2.64,1.75l-.07,0a3.16,3.16,0,0,0-2.22,3.87s0,0,0,.06a.09.09,0,0,1,0,0,2.91,2.91,0,0,0,.28.59s0,0,0,0a3.27,3.27,0,0,0,3.76,1.17l.19-.08a3.41,3.41,0,0,0,5.94-2.22l0,0A2.34,2.34,0,0,0,191.18,5.52Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M191.13,5.36a2.8,2.8,0,0,0-1.19-1.49,1.23,1.23,0,0,0,0-.19s0,0,0-.06V3.57A3.67,3.67,0,0,0,186,.91a3,3,0,0,0-2.64,1.75h-.07A3.18,3.18,0,0,0,181,6.55l0,.06a.11.11,0,0,0,0,0,2.46,2.46,0,0,0,.28.59v0l.12.15a2.73,2.73,0,0,1,2.86-3h.07a2.86,2.86,0,0,1,3-1A4.28,4.28,0,0,1,191,6.86a.43.43,0,0,1,0,0s0,0,0,.06v.19l.07.08a3,3,0,0,0,.2-1.17l0,0a3,3,0,0,0-.13-.64s0,0,0,0A.11.11,0,0,1,191.13,5.36Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M191.19,5.51a3,3,0,0,0-.33-.7,2.76,2.76,0,0,0-.4-.49c-.05-.05-.5-.37-.5-.4s0-.13,0-.19a.14.14,0,0,1,0-.06s0,0,0,0A3.66,3.66,0,0,0,186,1a3,3,0,0,0-2.64,1.75l-.07,0a3.16,3.16,0,0,0-2.22,3.87s0,0,0,.06a3.06,3.06,0,0,0,1.84,1.75,3.27,3.27,0,0,0,2.16,0l.06,0,.19-.08a3.3,3.3,0,0,0,3.59.95,3.38,3.38,0,0,0,2.36-3.14V6A1.43,1.43,0,0,0,191.19,5.51Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M193.76,38.1s0,0,0-.06l0,0c.65-1.52-.5-3.47-2.57-4.35a4,4,0,0,0-4.51.55,3.17,3.17,0,0,0-1.13,1.38s0,0,0,0a.08.08,0,0,1,0,.05,3.13,3.13,0,0,0-.19.62l0,0a2.78,2.78,0,0,0,1.52,3.13,2.6,2.6,0,0,0,2.26-.14,3.9,3.9,0,0,0,4.23-.65.43.43,0,0,0,0,0A2,2,0,0,0,193.76,38.1Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M185.44,36.12l0,0a.76.76,0,0,0,0,.15,2.83,2.83,0,0,1,.65-.6,4,4,0,0,1,4.51-.54,4.09,4.09,0,0,1,2.73,3.45l.13-.12a.43.43,0,0,0,0,0,2.24,2.24,0,0,0,.35-.55.13.13,0,0,1,0-.06l0,0c.65-1.52-.5-3.47-2.57-4.35a4,4,0,0,0-4.51.55,3.24,3.24,0,0,0-1.13,1.38s0,0,0,.06l0,0A2.86,2.86,0,0,0,185.44,36.12Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M193.77,38.1a2,2,0,0,0,.22-.78,3.38,3.38,0,0,0-1.15-2.58,5.19,5.19,0,0,0-1.6-1.1,4,4,0,0,0-4.51.55c-.16.18-.39.3-.56.49a3.17,3.17,0,0,0-.48.71,2.91,2.91,0,0,0,1.23,4,2.6,2.6,0,0,0,2.26-.14,3,3,0,0,1,.59.18,4.77,4.77,0,0,0,1.91.07A2.93,2.93,0,0,0,193.77,38.1Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M168.27,16.39s0,0,0-.05v-.06c.12-1.65,2-2.85,4.28-2.68a4,4,0,0,1,3.75,2.56,3.29,3.29,0,0,1,.37,1.75.43.43,0,0,1,0,.05V18a3.29,3.29,0,0,1-.12.64s0,0,0-.05a2.77,2.77,0,0,1-2.8,2.08,2.61,2.61,0,0,1-1.94-1.16A3.91,3.91,0,0,1,168.35,17l0,.05A2.08,2.08,0,0,1,168.27,16.39Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M176.57,18.48s0,0,0-.05,0,.09-.05.14a3.38,3.38,0,0,0-.31-.84,4,4,0,0,0-3.75-2.55,4.07,4.07,0,0,0-4,1.81,1.15,1.15,0,0,1-.06-.17l0,0a2.81,2.81,0,0,1-.05-.65s0,0,0-.06,0,0,0,0c.13-1.65,2-2.85,4.28-2.68A4,4,0,0,1,176.33,16a3.18,3.18,0,0,1,.36,1.75.43.43,0,0,0,0,.05v.06A3.43,3.43,0,0,1,176.57,18.48Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M168.26,16.39a2.11,2.11,0,0,1,.16-.8,3.4,3.4,0,0,1,2.21-1.75,5.05,5.05,0,0,1,1.93-.24,4,4,0,0,1,3.75,2.56c.06.23.21.45.27.69a3.12,3.12,0,0,1,.11.86,2.93,2.93,0,0,1-2.95,3,2.61,2.61,0,0,1-1.94-1.16c0-.06-.51-.09-.6-.12a4.31,4.31,0,0,1-.61-.19,3.93,3.93,0,0,1-1.11-.63A2.89,2.89,0,0,1,168.26,16.39Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M196.51,27.05a.11.11,0,0,1,0-.05s0,0,0,0c.11-1.36,1.68-2.34,3.52-2.2a3.31,3.31,0,0,1,3.09,2.1,2.65,2.65,0,0,1,.3,1.44s0,0,0,0v.05a2.28,2.28,0,0,1-.1.52,0,0,0,0,0,0,0,2.28,2.28,0,0,1-2.29,1.7,2.15,2.15,0,0,1-1.6-.95,3.25,3.25,0,0,1-2.84-2.08s0,0,0,0A1.64,1.64,0,0,1,196.51,27.05Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M203.33,28.76s0,0,0,0,0,.08,0,.12a2.58,2.58,0,0,0-.25-.69,3.3,3.3,0,0,0-3.08-2.1,3.36,3.36,0,0,0-3.3,1.49.78.78,0,0,1,0-.14l0,0a1.57,1.57,0,0,1,0-.53s0,0,0,0,0,0,0,0c.11-1.36,1.68-2.34,3.52-2.2a3.28,3.28,0,0,1,3.09,2.1,2.64,2.64,0,0,1,.3,1.43s0,0,0,.05v0A3,3,0,0,1,203.33,28.76Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M196.5,27.05a1.76,1.76,0,0,1,.13-.66A2.76,2.76,0,0,1,198.45,25a4.24,4.24,0,0,1,1.58-.19,3.31,3.31,0,0,1,3.09,2.1c0,.19.17.37.22.57A2.52,2.52,0,0,1,201,30.58a2.15,2.15,0,0,1-1.6-.95c0-.06-.42-.08-.49-.1a3.33,3.33,0,0,1-.51-.16,3.68,3.68,0,0,1-.91-.51A2.41,2.41,0,0,1,196.5,27.05Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M167.74,46.37s0,0,0,0,0,0,0-.06c.13-1.65,2-2.86,4.16-2.7a3.88,3.88,0,0,1,3.63,2.56,3.28,3.28,0,0,1,.35,1.75.43.43,0,0,1,0,.05V48a4.27,4.27,0,0,1-.11.64.08.08,0,0,1,0,0A2.71,2.71,0,0,1,173,50.66a2.46,2.46,0,0,1-1.88-1.16A3.78,3.78,0,0,1,167.82,47s0,0,0,0A2.81,2.81,0,0,1,167.74,46.37Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M175.78,48.44s0,0,0,0l-.06.14a3.34,3.34,0,0,0-.29-.84,3.88,3.88,0,0,0-3.63-2.55A4,4,0,0,0,167.9,47a1.77,1.77,0,0,1-.06-.17l0,0a2,2,0,0,1-.05-.65s0,0,0-.06v-.06c.12-1.65,2-2.86,4.15-2.69a3.88,3.88,0,0,1,3.63,2.55,3.19,3.19,0,0,1,.35,1.75s0,0,0,.06,0,0,0,.06A2.77,2.77,0,0,1,175.78,48.44Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M167.74,46.37a2.11,2.11,0,0,1,.16-.8A3.3,3.3,0,0,1,170,43.8a4.94,4.94,0,0,1,1.87-.24,3.88,3.88,0,0,1,3.63,2.56c.06.23.2.45.26.69a3.55,3.55,0,0,1,.1.86,2.9,2.9,0,0,1-2.86,3,2.46,2.46,0,0,1-1.88-1.16c0-.06-.49-.09-.58-.11a4.62,4.62,0,0,1-.6-.19,4.13,4.13,0,0,1-1.07-.63A2.9,2.9,0,0,1,167.74,46.37Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
        <path
          d="M173.26,32.53s0,0,0,0l0,0c.72-1.16-.37-3.13-2.42-4.39-1.74-1.07-3.61-1.29-4.57-.63a2.16,2.16,0,0,0-1.2.92s0,0,0,0l0,0a2.13,2.13,0,0,0-.21.49l0,0A2.87,2.87,0,0,0,166.31,32a3.12,3.12,0,0,0,2.28.43c1.67.93,3.39,1.1,4.3.47v0A1.28,1.28,0,0,0,173.26,32.53Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.30000000000000004"
        />
        <path
          d="M164.94,28.8l0,0s0,.08,0,.12a3,3,0,0,1,.68-.36c1-.66,2.84-.44,4.58.63s2.67,2.51,2.62,3.65a.91.91,0,0,0,.14-.07v0a1.37,1.37,0,0,0,.37-.39l0,0,0,0c.72-1.16-.37-3.12-2.42-4.39-1.74-1.07-3.61-1.29-4.57-.63a2.21,2.21,0,0,0-1.2.92s0,0,0,0l0,0A2.33,2.33,0,0,0,164.94,28.8Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M173.27,32.54a1.39,1.39,0,0,0,.26-.62,3.43,3.43,0,0,0-1.07-2.51,6.76,6.76,0,0,0-1.57-1.34c-1.74-1.07-3.61-1.29-4.57-.63-.17.11-.41.17-.59.29a2,2,0,0,0-.52.49,2.7,2.7,0,0,0,1.1,3.76,3.12,3.12,0,0,0,2.28.43,4.11,4.11,0,0,1,.59.3c.21.09.42.18.64.25a5.4,5.4,0,0,0,1.29.27A2.44,2.44,0,0,0,173.27,32.54Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #1d1d1b;
      stroke-miterlimit: 10;
      stroke-width: 0.5px;
    "
        />
      </g>
      <circle
        cx="182.47"
        cy="157.96"
        r="25.12"
        style="fill: none; stroke: #1c1463; stroke-miterlimit: 10"
      />
      <circle cx="222.16" cy="293.61" r="25.12" style="fill: #fff" />
      <circle
        cx="222.16"
        cy="293.61"
        r="25.12"
        style="fill: #231f20; opacity: 0.2"
      />
      <g style="clip-path: url(#bone-c)">
        <path
          d="M212.67,184.17c.86-1.26,1.51-2.72,2.75-3.61,1.78-1.29,4.34-1.07,6.09-2.4s2.19-3.87,3.63-5.59c1.61-1.95,4.32-2.63,6.16-4.36a16.83,16.83,0,0,0,2.38-3.23,43,43,0,0,1,8.76-9.88A30.77,30.77,0,0,0,238,161c-2,3.5-3.39,7.45-6.11,10.43a30.37,30.37,0,0,1-4.08,3.5l-10.32,7.8c-2,1.52-4.39,3.47-7,3.57A7.81,7.81,0,0,0,212.67,184.17Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M239.76,165.36a28.89,28.89,0,0,1,1.75-4.39c1.43-2.35,4.06-3.75,5.56-6.05a24.45,24.45,0,0,0,1.63-3.38,21.88,21.88,0,0,1,3.7-5.6A152.4,152.4,0,0,1,243,164.19c-1.22,1.95-3.08,4.71-5.59,4.83A25.17,25.17,0,0,0,239.76,165.36Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M223,169.85c-1,1.39-1.73,3.06-3,4.22-1.55,1.38-3.7,1.81-5.56,2.74a18.82,18.82,0,0,0-6,5.32l6.12-6.21a22.41,22.41,0,0,0,3.48-4.18c2.08-3.53,6.8-9.79,11.9-7.81C228.09,166.24,224.82,167.36,223,169.85Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M210.62,155.45c-1.27,1.18-2.26,2.7-3.74,3.6-1.77,1.08-4,1.11-6,1.68a18.77,18.77,0,0,0-6.83,4.16l7.14-5a22.28,22.28,0,0,0,4.19-3.48c2.68-3.09,8.45-8.39,13.11-5.52C216.33,152.83,212.91,153.34,210.62,155.45Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M221.09,153.13c1.39-1.51,2.36-3.39,4-4.61,2-1.46,4.72-1.74,7.1-2.64a22.21,22.21,0,0,0,7.76-5.62l-8,6.64a25.65,25.65,0,0,0-4.61,4.52c-2.82,3.92-9.11,10.75-15.32,7.93C214.46,156.83,218.6,155.85,221.09,153.13Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M197.13,195.19a15.26,15.26,0,0,0-4.86,1.44c2.11-.93,4.45.62,6.75.84s4.66-1,6.64-2.36a6.64,6.64,0,0,1,1.86-1,8.79,8.79,0,0,1,1.71-.22,12.83,12.83,0,0,0,7-3.28c1.33-1.15,4.18-3.5,4.14-5.34C212.76,189.5,205.85,193.49,197.13,195.19Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M224.79,191.37a15.35,15.35,0,0,0-4.43,2.46c1.86-1.37,4.47-.35,6.77-.63s4.33-2,6-3.74a6.66,6.66,0,0,1,1.6-1.4,9.73,9.73,0,0,1,1.62-.58,12.82,12.82,0,0,0,6.13-4.71c1.05-1.41,3.32-4.31,2.88-6.1C238.83,182.45,232.94,187.84,224.79,191.37Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M231.91,178.18c.36-.67.48-1.46.88-2.11a4.87,4.87,0,0,1,1.57-1.42c2.47-1.56,5.4-2.48,7.46-4.55,1.21-1.22,2-2.76,3.12-4.09a6,6,0,0,1,4.29-2.51c-2.47,1.81-3.48,5-5.56,7.25-1.64,1.77-3.92,2.94-5.19,5-.48.78-.79,1.65-1.23,2.45a10.63,10.63,0,0,1-6.09,4.69c-2.16.71-5.57,1.42-7.69.59C224.6,180.19,230.24,181.31,231.91,178.18Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M246.29,144.48c-.28.71-.3,1.5-.62,2.19a4.85,4.85,0,0,1-1.39,1.6c-2.28,1.84-5.08,3.09-6.88,5.39-1.06,1.35-1.7,3-2.62,4.42a6,6,0,0,1-4,3c2.24-2.09,2.87-5.38,4.68-7.86,1.41-1.95,3.55-3.38,4.57-5.56.38-.83.59-1.73.93-2.58a10.68,10.68,0,0,1,5.5-5.37c2.06-.95,5.37-2.06,7.57-1.49C253.32,141.63,247.59,141.17,246.29,144.48Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M212.14,164.72l-8.07,3.54a35.55,35.55,0,0,0-11.65,7.88C198.8,174.42,205.87,167.47,212.14,164.72Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M206.43,176.46a18.28,18.28,0,0,0-4,1.31c-1,.58-1.87,1.47-2.93,2a13.54,13.54,0,0,1-3.27.9,19.25,19.25,0,0,0-7.5,3.49c2-1.06,4.12-2.15,6.39-2.2,1.4,0,2.8.35,4.2.34a11.7,11.7,0,0,0,5.85-2c2.29-1.4,5.66-3.74,6.5-6.38A22.06,22.06,0,0,1,206.43,176.46Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M224.77,140.58a17.93,17.93,0,0,0-4,1.31c-1,.58-1.87,1.46-2.93,2a13.88,13.88,0,0,1-3.27.9,19.37,19.37,0,0,0-7.5,3.48c2-1.06,4.12-2.14,6.39-2.19,1.41,0,2.8.35,4.21.34a11.59,11.59,0,0,0,5.84-2c2.29-1.39,5.66-3.73,6.5-6.37A21.7,21.7,0,0,1,224.77,140.58Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M217.86,164.1a26.32,26.32,0,0,1-3.73,3.27,56.33,56.33,0,0,1-5.51,2.72,20.55,20.55,0,0,0-6.45,5.15,123.24,123.24,0,0,0,21.17-13.49c1.55-1.22,5.51-3.92,4.55-6.21C224.41,156.68,220.53,161.48,217.86,164.1Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M212.67,185.4c.86-1.26,1.51-2.72,2.75-3.61,1.78-1.29,4.34-1.07,6.09-2.4s2.19-3.88,3.63-5.6c1.61-1.94,4.32-2.62,6.16-4.35a16.9,16.9,0,0,0,2.38-3.24,43.42,43.42,0,0,1,8.76-9.88A31.16,31.16,0,0,0,238,162.2c-2,3.5-3.39,7.44-6.11,10.43a29.59,29.59,0,0,1-4.08,3.49l-10.32,7.81c-2,1.52-4.39,3.47-7,3.57A7.81,7.81,0,0,0,212.67,185.4Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M239.76,166.59a28.89,28.89,0,0,1,1.75-4.39c1.43-2.35,4.06-3.75,5.56-6a24.57,24.57,0,0,0,1.63-3.39,22,22,0,0,1,3.7-5.59A153.16,153.16,0,0,1,243,165.42c-1.22,2-3.08,4.71-5.59,4.82A24.52,24.52,0,0,0,239.76,166.59Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M223,171.08c-1,1.39-1.73,3.06-3,4.22-1.55,1.38-3.7,1.81-5.56,2.73a18.73,18.73,0,0,0-6,5.33l6.12-6.21A22.41,22.41,0,0,0,218,173c2.08-3.53,6.8-9.79,11.9-7.81C228.09,167.47,224.82,168.59,223,171.08Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M210.47,155.75c-1.2,1.25-2.09,2.82-3.52,3.81-1.7,1.18-3.9,1.34-5.85,2a18.71,18.71,0,0,0-6.57,4.56l6.83-5.42a21.87,21.87,0,0,0,4-3.71c2.49-3.26,7.95-8.89,12.77-6.3C216,152.8,212.64,153.51,210.47,155.75Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M221,153.36c1.45-1.46,2.49-3.3,4.22-4.45,2.07-1.38,4.79-1.56,7.19-2.36a22.28,22.28,0,0,0,8-5.32l-8.27,6.33a24.76,24.76,0,0,0-4.78,4.34c-3,3.8-9.52,10.38-15.61,7.33C214.2,156.8,218.37,156,221,153.36Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M197.13,195.26a15.62,15.62,0,0,0-4.86,1.45c2.12-.94,4.45.62,6.75.84s4.66-1,6.64-2.37a6.9,6.9,0,0,1,1.86-1,8.89,8.89,0,0,1,1.71-.21,12.78,12.78,0,0,0,7-3.29c1.33-1.15,4.17-3.5,4.13-5.33C212.76,189.57,205.85,193.57,197.13,195.26Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M224.32,191.51a15.14,15.14,0,0,0-4.44,2.45c1.87-1.36,4.48-.35,6.77-.63s4.34-2,6-3.74a7,7,0,0,1,1.59-1.39,8.55,8.55,0,0,1,1.63-.58,12.87,12.87,0,0,0,6.12-4.71c1.06-1.42,3.33-4.32,2.89-6.1C238.35,182.59,232.46,188,224.32,191.51Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M231.91,178.66c.36-.68.48-1.46.88-2.11a4.75,4.75,0,0,1,1.57-1.42c2.47-1.56,5.4-2.48,7.46-4.56a50,50,0,0,0,3.12-4.08,6,6,0,0,1,4.29-2.52c-2.47,1.81-3.48,5-5.56,7.26-1.64,1.77-3.92,2.94-5.19,5-.48.78-.79,1.65-1.23,2.44a10.65,10.65,0,0,1-6.09,4.7c-2.16.7-5.57,1.42-7.69.59C224.6,180.67,230.24,181.79,231.91,178.66Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M246.29,145.7c-.28.71-.3,1.51-.62,2.2a4.72,4.72,0,0,1-1.39,1.59c-2.28,1.85-5.08,3.1-6.88,5.4-1.06,1.35-1.7,3-2.62,4.42a5.93,5.93,0,0,1-4,3c2.24-2.09,2.87-5.38,4.68-7.85,1.41-2,3.55-3.38,4.57-5.57.38-.82.59-1.72.93-2.57a10.64,10.64,0,0,1,5.5-5.37c2.06-1,5.37-2.06,7.57-1.49C253.32,142.85,247.59,142.4,246.29,145.7Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M211.92,164.35l-8,3.69a35.72,35.72,0,0,0-11.49,8.1C198.76,174.3,205.7,167.21,211.92,164.35Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M206.69,177.74a18.83,18.83,0,0,0-4,1.31c-1,.59-1.87,1.47-2.93,2a14,14,0,0,1-3.27.91,19.37,19.37,0,0,0-7.5,3.48c2-1.06,4.12-2.15,6.39-2.19,1.41,0,2.8.35,4.2.33a11.48,11.48,0,0,0,5.85-2c2.29-1.4,5.66-3.73,6.5-6.38A21.32,21.32,0,0,1,206.69,177.74Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M224.9,141.53a18,18,0,0,0-4.07,1.1c-1.06.52-2,1.37-3,1.84a13.31,13.31,0,0,1-3.32.73,19.31,19.31,0,0,0-7.67,3.09c2.07-.95,4.22-1.93,6.5-1.86,1.4,0,2.77.5,4.18.56a11.56,11.56,0,0,0,5.94-1.66c2.36-1.27,5.85-3.43,6.82-6A21.48,21.48,0,0,1,224.9,141.53Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M217.86,164.85a25.77,25.77,0,0,1-3.73,3.28,61.23,61.23,0,0,1-5.51,2.72,20.41,20.41,0,0,0-6.45,5.15,123.85,123.85,0,0,0,21.17-13.49c1.55-1.22,5.51-3.92,4.55-6.21C224.41,157.44,220.53,162.24,217.86,164.85Z"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
      </g>
      <circle
        cx="222.16"
        cy="293.61"
        r="25.12"
        style="fill: none; stroke: #1c1463; stroke-miterlimit: 10"
      />
      <circle cx="96.56" cy="292.75" r="25.12" style="fill: #fff" />
      <g style="clip-path: url(#bone-d)">
        <circle cx="96.56" cy="292.75" r="25.12" style="fill: url(#bone-e)" />
        <path
          d="M236.29,7.51c13.39-20.16,34.25-54.16,47.32-83.68,4.15-9.38,8.14-18.89,13.56-27.6s12.4-16.68,21.32-21.75a10,10,0,0,1,5.51-1.69c1.95.15,3.91,1.69,3.87,3.64-3.67,3.4-4.09,10.29-.71,14.72a12.16,12.16,0,0,0,15,3.21c6.31-3.45,8.55-12,15-15.21,6-3,13.68.16,17.3,5.74s3.74,12.84,2,19.26c-1.54,5.74-4.94,11.53-10.54,13.49-6.91,2.42-14.28-1.7-21.59-2.12-7.74-.45-15.24,3.38-20.88,8.7s-9.71,12.05-13.72,18.69Q278.8-5.8,247.88,45.38,220.33,87.62,188.69,127c-10.95,13.63-22.54,27.51-27.41,44.3-2.48,8.57-3.56,18.42-10.36,24.19a17.32,17.32,0,0,1-22-.25c-3.81-3.39-5.95-8.38-9.9-11.59-6.76-5.49-17.81-5-22.65-12.21-3.87-5.77-1.54-14,3.19-19s11.32-7.94,17.45-11.21C144.85,126.36,185.58,77,185.58,77S224.35,25.49,236.29,7.51Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: #fff;
      stroke: #231f20;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 0.467631316910455px;
    "
        />
        <path
          d="M97.72,154.54c-2.6,3.87-1.51,9.48,1.79,12.79s8.28,4.49,12.92,4c3.25-.33,6.51-1.38,9.72-.78,4.85.91,8.19,5.28,10.84,9.45s5.4,8.75,10,10.59a11.47,11.47,0,0,0,14.59-6.81,17.56,17.56,0,0,1-28.33,11.36c-3.56-2.83-5.88-6.92-9.11-10.13a24.41,24.41,0,0,0-8.8-5.62c-3.35-1.24-7-1.76-10.08-3.54a14,14,0,0,1-6.71-9.81A15.28,15.28,0,0,1,97.72,154.54Z"
          transform="translate(-1.88 127.46)"
          style="fill: #d0d2d3"
        />
        <path
          d="M377.11-98.34s-10.31,11.16-29.5,6.84-33.46,6.33-38.87,15.91-79.83,137.91-99,158.07C192.09,101,177.77,123,163.43,144.07c-4.19,6.15-9.41,12.32-10.89,19.82-1.35,6.84,1.58,14.1,5,19.92,0,0,4.31-19.79,12.38-31.54s52.4-69.59,52.4-69.59,32.34-42.6,57.84-90.78,43.28-67.68,43.28-67.68,8.15-9.86,20.88-8.7,18.06,6.29,25.53-.55,7.24-13.31,7.24-13.31"
          transform="translate(-1.88 127.46)"
          style="fill: #231f20; opacity: 0.2"
        />
        <path
          d="M236.29,7.51c13.39-20.16,34.25-54.16,47.32-83.68,4.15-9.38,8.14-18.89,13.56-27.6s12.4-16.68,21.32-21.75a10,10,0,0,1,5.51-1.69c1.95.15,3.91,1.69,3.87,3.64-3.67,3.4-4.09,10.29-.71,14.72a12.16,12.16,0,0,0,15,3.21c6.31-3.45,8.55-12,15-15.21,6-3,13.68.16,17.3,5.74s3.74,12.84,2,19.26c-1.54,5.74-4.94,11.53-10.54,13.49-6.91,2.42-14.28-1.7-21.59-2.12-7.74-.45-15.24,3.38-20.88,8.7s-9.71,12.05-13.72,18.69Q278.8-5.8,247.88,45.38,220.33,87.62,188.69,127c-10.95,13.63-22.54,27.51-27.41,44.3-2.48,8.57-3.56,18.42-10.36,24.19a17.32,17.32,0,0,1-22-.25c-3.81-3.39-5.95-8.38-9.9-11.59-6.76-5.49-17.81-5-22.65-12.21-3.87-5.77-1.54-14,3.19-19s11.32-7.94,17.45-11.21C144.85,126.36,185.58,77,185.58,77S224.35,25.49,236.29,7.51Z"
          transform="translate(-1.88 127.46)"
          style="
      fill: none;
      stroke: #231f20;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 0.467631316910455px;
    "
        />
        <polygon
          points="83.55 274.78 91.17 280.8 92.28 279.03 97.99 282 91.41 276.26 90.43 278.03 83.55 274.78"
          style="fill: #1c1463; opacity: 0.25"
        />
        <polygon
          points="75.55 294.66 85.23 295.37 85.15 293.28 91.55 292.53 82.89 291.48 83.06 293.5 75.55 294.66"
          style="fill: #1c1463; opacity: 0.25"
        />
        <polygon
          points="87.09 315.35 96.34 309.31 94.79 307.44 100.04 302.32 91.46 307.34 93.05 309.07 87.09 315.35"
          style="fill: #1c1463; opacity: 0.25"
        />
        <polygon
          points="80.89 308.11 86.4 304.31 85.63 303.37 88.85 300.28 83.77 303.49 84.57 304.36 80.89 308.11"
          style="fill: #1c1463; opacity: 0.25"
        />
        <polygon
          points="76.06 282.68 82.09 285.62 82.53 284.48 86.8 285.77 81.5 282.92 81.14 284.04 76.06 282.68"
          style="fill: #1c1463; opacity: 0.25"
        />
      </g>
      <circle
        cx="96.56"
        cy="292.75"
        r="25.12"
        style="fill: none; stroke: #1c1463; stroke-miterlimit: 10"
      />
      <circle
        cx="140.84"
        cy="280.33"
        r="12.42"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <line
        x1="129.21"
        y1="284.65"
        x2="122.06"
        y2="287.3"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <circle
        cx="232.37"
        cy="169.22"
        r="12.42"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <line
        x1="243.79"
        y1="174.07"
        x2="260.6"
        y2="181.21"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <circle
        cx="176.02"
        cy="252.43"
        r="12.42"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <line
        x1="185.49"
        y1="260.44"
        x2="204.09"
        y2="276.18"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <circle
        cx="212.31"
        cy="203.61"
        r="12.42"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <line
        x1="205.71"
        y1="193.11"
        x2="196.64"
        y2="178.67"
        style="
    fill: none;
    stroke: #1c1463;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
      <polyline
        points="411.79 182.46 321.5 182.46 309.25 189.98"
        style="
    fill: none;
    stroke: #6f6f6e;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  "
      />
    </svg> `;
  }
}

customElements.define("bone-glass-state", BoneGlass);
